:host {
  --icon-offset-x: 0.75rem;
  --icon-offset-y: 0%;
  --input-margin-top: theme('width.4');
  --input-margin-bottom: theme('width.4');
  --text-align: left;
  /* The Token below NOT from XDS and subject to change */
  --input-padding-minimal: var(--space-asym-1, calc(theme('spacing.3') - theme('spacing.px')) 0 theme('spacing.2') 0);
  /* The Token below NOT from XDS and subject to change */
  --input-padding-contained: var(--space-sym-1, calc(theme('spacing.4') - theme('spacing.px')));
  @apply block relative box-border w-full isolate;
  margin-top: var(--input-margin-top);
  margin-bottom: var(--input-margin-bottom);
}

.screen-reader-text {
  @apply sr-only;
}

.label-text {
  @apply text-neutral-base inline-block text-left mb-1 cursor-pointer;
}

.hint-container {
  @apply flex items-center space-x-1 mt-1;
}

.hint-text {
  @apply block text-left;
}

@media (prefers-reduced-motion) {
  .input {
    transition: none;
  }
}
/* Variant: Minimal */
.input {
  @apply bg-transparent w-full outline-none box-border text-body1 text-neutral-base;
  @apply border-b border-t-0 border-l-0 border-r-0 border-stroke-neutral2-base border-solid;
  text-align: var(--text-align, left);
  transition:
    border-color,
    box-shadow,
    border-radius,
    padding 0.2s ease-in-out;
}
/* Text Display */
.input.body1 {
  @apply text-body1;
}

.input.heading1 {
  @apply text-headline1;
}
/* https://learn.microsoft.com/en-us/microsoft-edge/web-platform/password-reveal */
.input::-ms-reveal {
  display: none;
}

.input.minimal {
  /* @apply px-0 pt-3 pb-2; */
  padding: var(--input-padding-minimal);
}
/* Variant: Contained */
.input.contained {
  @apply bg-material-neutral2-base border rounded-small;
  /* @apply p-4; */
  padding: var(--input-padding-contained);
}

.input::placeholder {
  @apply text-neutral2-base;
}

.input.contained:focus {
  @apply ring-2 ring-stroke-theme1-base border-transparent;
}

.input.minimal:focus {
  @apply border-b-2 border-stroke-theme1-base;
}
/* Valid States */
.input.minimal.valid,
.input.contained.valid,
.input.minimal.valid:focus {
  @apply border-stroke-positive-base;
}

.input.contained.valid:focus {
  @apply ring-2 ring-stroke-positive-base border-transparent;
}
/* Invalid States */

.input.minimal.invalid,
.input.contained.invalid,
.input.minimal.invalid:focus {
  @apply border-stroke-negative-base;
}

.input.contained.invalid:focus {
  @apply ring-2 ring-stroke-negative-base border-transparent;
}
/* Icon Spacing */
.input.icon-leading {
  @apply pl-12;
}

.input.minimal.icon-leading {
  @apply pl-8;
}

.input.icon-trailing {
  @apply pr-14;
}

.input.minimal.icon-trailing {
  @apply pr-8;
}
/* Disabled State */
.input.disabled::placeholder,
.input.disabled,
.input.minimal.disabled,
.input.contained.disabled {
  @apply cursor-not-allowed text-opacity-inactive border-opacity-inactive;
}
/* Generic Status Colors for Text */
.invalid-text {
  @apply text-negative-base;
}

.valid-text {
  @apply text-positive-base;
}

.wrap {
  @apply block relative;
}
/** Icons: Search **/
.icon-trailing-manual,
.icon-search,
.prism-input-text-icon-leading,
.prism-input-text-icon-trailing,
::slotted([css-slot^='icon-']) {
  @apply absolute z-base;
  --button-padding-xs: theme(spacing[1.5]);
  --icon-color: inherit;
  top: calc(50% - var(--icon-offset-y));
  transform: translateY(-50%);
}

.icon-search {
  @apply pointer-events-none;
}

:host(.contained) .icon-search,
:host(.contained) ::slotted([css-slot='icon-leading']) {
  @apply left-4;
}

:host(.minimal) .icon-search,
:host(.minimal) ::slotted([css-slot='icon-leading']) {
  @apply left-0;
}

:host(.contained) .icon-trailing-manual,
:host(.contained) ::slotted([css-slot='icon-trailing']) {
  @apply right-4;
}

:host(.minimal) .icon-trailing-manual,
:host(.minimal) ::slotted([css-slot='icon-trailing']) {
  @apply right-0;
}

::slotted(button[css-slot*='icon-']) {
  @apply appearance-none border-none cursor-pointer;
  background: theme('backgroundColor.transparent');
}

::slotted(button[css-slot*='icon-']):focus {
  @apply outline-neutral-base;
}
/* Custom Types */
/* Date & Date Time */
.invalid.month.contained,
.valid.month.contained,
.invalid.datetime-local.contained,
.valid.datetime-local.contained,
.invalid.date.contained,
.valid.date.contained {
  @apply pr-14;
}

.invalid.month,
.valid.month,
.invalid.datetime-local,
.valid.datetime-local,
.invalid.date,
.valid.date {
  @apply pr-6;
}

.number::-webkit-outer-spin-button,
.number::-webkit-inner-spin-button {
  @apply appearance-none;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -moz-appearance: textfield;
}
